import { Link } from 'react-router-dom';
import linkIcon from 'images/icons/svg/link-1.svg';
import React from 'react';
import styled from 'styled-components';
import { VersionHistoryModel } from 'types/epd-definition/VersionHistoryModel';
import { formatDate } from 'util/utils';
import { EpdLinks } from 'routes/EpdRoutes';

interface Props {
  epdId: string;
  data: VersionHistoryModel;
  onClick: React.MouseEventHandler<HTMLAnchorElement>;
}

const WizardVersionItem: React.FunctionComponent<Props> = ({ epdId, data, onClick }) => {
  return (
    <StyledLink
      to={EpdLinks.epdWizardVersionHistory(epdId, data.id)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
    >
      <FullIdentificationNumberContainer>{data.fullIdentificationNumber}</FullIdentificationNumberContainer>
      <VersionDateAndDetailsContainer>
        {formatDate(data.versionDate)}
        <ShowDetailsIcon src={linkIcon} alt="link" />
      </VersionDateAndDetailsContainer>
    </StyledLink>
  );
};

const StyledLink = styled(Link)`
  background-color: #b4d0b64d;
  color: inherit;
  text-align: justify;
  text-decoration: none;
  padding: 14px 16px 14px 16px;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const FullIdentificationNumberContainer = styled.div`
  font-size: 14px;
  color: ${(props) => props.theme.colors.primaryBlack};
`;

const VersionDateAndDetailsContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: ${(props) => props.theme.colors.primaryBlack};
`;

const ShowDetailsIcon = styled.img`
  width: 15px;
  height: 15px;
  margin-left: 10px;
`;

export default WizardVersionItem;
